import billTo from './billTo';
import city from './city';
import name from './name';
import province from './province';
import shipTo from './shipTo';

export default [name, city, province, billTo, shipTo];



// WEBPACK FOOTER //
// ./src/compositions/TechAdmin/DealersTable/columns/index.js